export default __webpack_public_path__ + "static/media/celularCores.b8fc1656.png";